import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid } from '@mui/material';
import createToast from 'components/Toast/Toast';
import {
  PageContainer,
  FilterPod,
  TableComponents,
  ButtonLoading,
  SimpleDialog,
  ConfirmDialog
} from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns, generateData } from './components/Columns';
import SubsetServices from '../../Subsets/services/SubsetServices';
import Services from '../services/Services';
import InitFilters from './constants/InitFiltering';
import { useStyles } from './style';
import { object } from 'prop-types';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

export default function CartableList() {
  //-- STATES --//
  let tableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [filters, setFilters] = useState(InitFilters());
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [dialog, setDialog] = useState({});
  const [dataRecoder, setDataRecoder] = useState({});
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'listWarrantyPage',
      'cancelListWarrantyPage',
      'listWarrantyDetailPage'

    ]);
  //--HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();
  useEffect(() => {
    if (actionsList['listWarrantyPage']) {
      getCredit();
    }
  }, []);
  const showDialog = (data) => {
    setDataRecoder(data)
    setConfirmDeleteModal(true);
  }
  const deleteFile = async () => {
    setIsLoadingBtn(true)
    await Services.postWarrantiesCancel(dataRecoder?.source?.entityId)
      .then((res) => {
        setConfirmDeleteModal(false);
        createToast('موفق', 'درخواست لغو با موفقیت انجام شد.', 'success');
        setIsLoadingBtn(false)
        setPage(0)
        setSize(10)
        setTimeout(() => {
          tableRef?.current?.onChangeTable();
        }, 100)
      })
      .catch((error) => {
        setConfirmDeleteModal(false);
        setIsLoadingBtn(false)

      });
  };

  const getCredit = async () => {
    try {
      const result = await Services.getRequestList();
      const cartablist = result;
      let list = [];
      list = cartablist?.map((val) => ({
        name: val?.guildSrv?.name,
        label: val?.guildSrv?.name,
        value: val?.guildSrv?.code,
        id: val?.guildSrv?.code,
      }));
      return list;
    } catch (error) {
      return [];
    }
  };
  //--API REQUESTS--//
  const getBranchesList = async (query) => {
    setLoading(true);
    try {
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });
      const res = await Services.getRequestList(params);
      let list = [];
      let mappedData = mapCamelCase(res?.result);

      list = generateData(Object.values(mappedData), {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };
  const toCamelCase = (str) => {
    return str.replace(/[-\s](\w)/g, (match, letter) => letter.toUpperCase());
  };


  const mapCamelCase = (obj) => {
    let result = {};
    for (let key in obj) {
      let camelKey = toCamelCase(key);
      result[camelKey] = obj[key];
      if (typeof obj[key] === 'object') {
        result[camelKey] = mapCamelCase(obj[key]);
      }
    }
    return result;
  };
  const changeStateOfBranch = async (selectedRow, changeStatusGroup) => {
    setLoadingBtn(true);

    try {
      if (Array.isArray(selectedRow)) {
        const filterBaseOnSameState = selectedRow.filter(
          (row) => row.branchInfoSrv.enable !== changeStatusGroup,
        );

        if (filterBaseOnSameState.length) {
          await SubsetServices.changeStateOfBranch({
            branchId: filterBaseOnSameState.map((row) => row.id),
            enable: changeStatusGroup,
          });
        }
      } else {
        await SubsetServices.changeStateOfBranch({
          branchId: [selectedRow.id],
          enable: !selectedRow.branchInfoSrv.enable,
        });
      }
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {

    } finally {
      setLoadingBtn(false);
      handleCloseDialog();
    }
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false, onAccept: () => null });
  };

  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={dialog?.onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  const ChangeStateGroupActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="فعال‌سازی"
          onClick={() => changeStateOfBranch(dialog.data, true)}
        />

        <ButtonLoading
          type="submit"
          variant="outlined"
          color="primary"
          loading={loadingBtn}
          name="غیرفعال‌سازی"
          onClick={() => changeStateOfBranch(dialog.data, false)}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  const hint = 'در این بخش می توانید لیست درخواست های ضمانت‌نامه دیجیتال خود را مشاهده کنید.';


  return (
    <PageContainer
      title="لیست درخواست ها "
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.WARRANTY_REQUEST_LIST}
      className={classes.root}

    >
      {actionsList['listWarrantyPage'] && (
        <>
          <Grid item xs={12}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          <TableComponents
            data={getBranchesList}
            columns={columns(showDialog, navigate, actionsList)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getBranchesList(ps)
            }}
          />
        </>
      )}

      {dialog.type === 'ChangeStateActionBtn' && (
        <SimpleDialog
          title={dialog?.title}
          content={dialog?.content}
          open={dialog?.open || false}
          actions={<ChangeStateActionBtn />}
        />
      )}

      {dialog.type === 'ChangeStateGroupActionBtn' && (
        <SimpleDialog
          title={dialog?.title}
          content={dialog?.content}
          open={dialog?.open || false}
          actions={<ChangeStateGroupActionBtn />}
        />
      )}
      <ConfirmDialog
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={deleteFile}
        title="لغو درخواست ضمانت‌نامه"
        content="آیا از لغو درخواست خود اطمینان دارید؟"
        confirmButtonText="بله "
        cancelButtonText="خیر"
        loading={isLoadingBtn}
      />
    </PageContainer>
  );
}
